/**
2  *  Copyright (c) 2018 Micro Focus Software Inc.  All Rights Reserved.
3  *
4  * THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
5  * AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
6  * WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
7  * TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
8  * AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
9  * INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
10  * PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
11  * CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
12  * OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
13  * ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
14  * THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
15  */


import { Component, ViewEncapsulation, Output, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { StoreItemsService } from '../services/storeitems.service';
import { StoreItemsResponse } from '../model/storeitemsresponse';
import { StoreItemsResultEntity } from '../model/storeitemsresponse';
import { DomSanitizer } from '@angular/platform-browser';
import { InfiniteScrollService } from '../../shared/services/infinite-scroll.service';
import { StoreItemFilterInfo } from '../model/storeitemfilterinfo';
import { StoreFilterService } from '../services/storefilter.service';
import { AlertService } from '../../../../shared/alert/alert.service';
import { SpinnerService } from '../../../../shared/spinner/spinner.service';
import { Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { StoreCategoriesResultEntity } from '../model/storecategoriesresponse';
import { StoreCapableItemTypesResultEntity } from '../model/storecapableitemtypesresponse';
import { PlatformLocation } from '@angular/common';
import { BannerComponent } from '../../../view/banner/banner.component';


@Component({
    selector: 'zsd-storeitems',
    templateUrl: '../view/storeitems.component.html',
    styleUrls: ['../view/storeitems.component.scss'
    ],
    encapsulation: ViewEncapsulation.None
})

export class StoreItemsComponent implements OnDestroy, OnInit {

    isStoreItems: boolean;
    storeItemDetails: StoreItemsResultEntity[] = [];
    storeItemFilterInfo: StoreItemFilterInfo = new StoreItemFilterInfo();
    rowList = [];
    page;
    isLoading;
    maxNoOfItems;
    scrollEndReached = false;
    filterSubscription: Subscription;

    @Output() openfilter = new EventEmitter<boolean>();

    constructor(private storeItemsService: StoreItemsService, private alertService: AlertService,
        private spinnerService: SpinnerService, public _DomSanitizer: DomSanitizer,
        public infiniteScrollService: InfiniteScrollService, public storeFilterService: StoreFilterService,
        private route: ActivatedRoute, private location: PlatformLocation) {
        this.subscribeAndApplyFilters();

        this.location.onPopState(() => {
            this.ngOnInit();
        });
        this.location.onHashChange(() => {
            this.ngOnInit();
        });
    }

    ngOnInit() {
        /* To refresh Global search dropdown */
       BannerComponent.refreshGlobalSearchDropdown.next(false);

        this.initializeParameters();
        let categoryIds = new Array<number>();
        let itemTypeIds = new Array<number>();
        let categoryResults = new Array<StoreCategoriesResultEntity>();
        let storeCapableItemTypesResults = new Array<StoreCapableItemTypesResultEntity>();

        this.route.queryParams.subscribe(params => {
            if (params['searchTerm']) {
                this.storeItemFilterInfo.searchTerm = JSON.parse(params['searchTerm']);
            }
            if (params['myRequested']) {
                this.storeItemFilterInfo.myRequested = JSON.parse(params['myRequested']);
            }
            if (params['storeCategories']) {
                categoryIds = JSON.parse(params['storeCategories']);
            }
            if (params['storeCapableItemTypes']) {
                itemTypeIds = JSON.parse(params['storeCapableItemTypes']);
            }
        });

        for (let i = 0; i < categoryIds.length; i++) {
            let storeCategory = new StoreCategoriesResultEntity();
            storeCategory.storeCategoryId = categoryIds[i];
            categoryResults[i] = storeCategory;
        }
        this.storeItemFilterInfo.storeCategories = categoryResults;

        for (let i = 0; i < itemTypeIds.length; i++) {
            let storeItemType = new StoreCapableItemTypesResultEntity();
            storeItemType.itemTypeId = itemTypeIds[i];
            storeCapableItemTypesResults[i] = storeItemType;
        }
        this.storeItemFilterInfo.storeCapableItemTypes = storeCapableItemTypesResults;

        this.getStoreItems(this.storeItemFilterInfo);
    }

    initializeParameters() {
        this.infiniteScrollService.initialize(225, window.innerWidth, 0, 24, 0);
        this.isLoading = false;
        this.page = 0;
        this.isStoreItems = false;
        this.storeItemDetails = [];
        this.storeItemFilterInfo = new StoreItemFilterInfo();
    }

    deleteAlert() {
        this.alertService.delAlert();
    }

    scrollEnd() {
        if (!this.scrollEndReached) {
            this.getStoreItems(this.storeItemFilterInfo);
        }
    }

    scrollCur(event) {
        this.infiniteScrollService.onScrollUpdate(event.curPos);
        const viewList = this.storeItemDetails.slice(this.infiniteScrollService.viewStart, this.infiniteScrollService.viewEnd);
        this.rowList = this.infiniteScrollService.getRowWiseData(viewList);
    }

    onResize() {
        const viewStart = this.infiniteScrollService.viewStart;
        const viewEnd = this.infiniteScrollService.viewEnd;
        this.infiniteScrollService.initialize(225, window.innerWidth, viewStart, viewEnd, 0);
        const viewList = this.storeItemDetails.slice(this.infiniteScrollService.viewStart, this.infiniteScrollService.viewEnd);
        this.rowList = this.infiniteScrollService.getRowWiseData(viewList);
    }

    subscribeAndApplyFilters() {
        this.filterSubscription = this.storeFilterService.getFilter().pipe(
            debounceTime(400)).subscribe((filterInfo: StoreItemFilterInfo) => {
            this.initializeParameters();
            this.storeItemFilterInfo = filterInfo;
            this.getStoreItems(this.storeItemFilterInfo);
        });
    }

    getStoreItems(storeItemFilterInfo: StoreItemFilterInfo) {
        if (!this.isLoading) {
            this.isLoading = true;
            this.spinnerService.show();
            this.storeItemsService.getStoreItems(this.page, 24, 'schStoreItemName', 'ASC', storeItemFilterInfo).subscribe(
                (storeItemResponse: StoreItemsResponse) => {
                    this.maxNoOfItems = storeItemResponse.resultCount;
                    if (this.maxNoOfItems > 0) {
                        this.isStoreItems = true;
                    }
                    if (this.storeItemDetails.length >= this.maxNoOfItems) {
                        this.scrollEndReached = true;
                    } else {
                        this.storeItemDetails = this.storeItemDetails.concat(storeItemResponse.results);
                        this.page++;
                        this.infiniteScrollService.totalNoOfItems = this.storeItemDetails.length;
                        this.infiniteScrollService.updateTotalHeight();

                        const viewList = this.storeItemDetails.slice(this.infiniteScrollService.viewStart,
                            this.infiniteScrollService.viewEnd);
                        this.rowList = this.infiniteScrollService.getRowWiseData(viewList);
                        this.infiniteScrollService.updateTranslateValue();
                    }
                    this.isLoading = false;
                },
                err => {
                    console.error(err.error);
                    this.isLoading = false;
                }
            );
        }
    }
    openFilter() {
        this.openfilter.emit(true);
    }
    trackByItemName(index) {
        return index;
    }
    ngOnDestroy() {
        this.filterSubscription.unsubscribe();
    }
}
